import React from 'react';
import PropTypes from 'prop-types';
import cloraLogo from '../../../../assets/images/Logo_Gray.svg';

function ProjectDetailsNav({
  displayExit, reviewPath, homePath, isProjectNew, projectsPath,
}) {
  return (
    <nav className="navbar project-questions navbar-default navbar--light style-guide mb-4">
      <div className="container">
        <div className="navbar-header">
          <a href={homePath} className="navbar-brand">
            <img
              src={cloraLogo}
              alt="Clora"
              id="clf-nav-logo"
              height={34}
              width={80}
            />
          </a>
        </div>

        <ul className="nav navbar-nav navbar-right">
          {
          displayExit
          && (
          <li>
            <a
              href={isProjectNew ? projectsPath : reviewPath}
              className="heavy-green-navbar medium-weight"
            >
              Exit Project Questions
            </a>
          </li>
          )
        }
        </ul>
      </div>
    </nav>
  );
}

ProjectDetailsNav.propTypes = {
  isProjectNew: PropTypes.bool.isRequired,
  displayExit: PropTypes.bool.isRequired,
  reviewPath: PropTypes.string.isRequired,
  homePath: PropTypes.string.isRequired,
  projectsPath: PropTypes.string.isRequired,
};

ProjectDetailsNav.defaultProps = {
};

export default ProjectDetailsNav;
